// src/components/Layout.js

import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Header from './HeaderComponent';
import Footer from './Footer';
import Sidebar from './SidebarComponent';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchMyModules } from '../../store/EmployeeModules/employeeModulesSlice';
import EmployeeModuleGuard from '../Components/EmployeeModuleGuard';

const AuthenticatedLayout = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isDashboardNew = location.pathname.replace(/\/$/, '') === '/dashboard-new';

  useEffect(() => {
    dispatch(fetchMyModules());
  }, [dispatch]);

  if (isDashboardNew) {
    return (
      <>
        <ToastContainer position="bottom-right" autoClose={3000} />
        <EmployeeModuleGuard>{children}</EmployeeModuleGuard>
      </>
    );
  }

  return (
    <div className="flex justify-center">
      <ToastContainer position="bottom-right" autoClose={3000} />
      <div className="flex flex-1 w-full flex-nowrap">
        <Sidebar />
        <div className="flex-1 bg-white mt-6 ml-3">
          <EmployeeModuleGuard>{children}</EmployeeModuleGuard>
        </div>
      </div>
    </div>
  );
};

export default AuthenticatedLayout;
